import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import styled from 'styled-components';
import diamondsBackground from 'assets/images/join/diamondsBackground.png';

const MobileWrapper = styled.div`
  background: ${props => props.theme.colors.siteGrey};
  min-height: 100vh;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const MobileContent = styled.div`
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
  padding: 12px 8px 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const MobileTitle = styled.div`
  font-family: ${props => props.theme.fonts.montserratBold};
  font-size: 20px;
  color: ${props => props.theme.colors.siteBlack};
  text-align: center;
  margin: 24px 0 10px 0;
  margin-top: 80px;
`;
const MobileSubtitle = styled.div`
  font-family: ${props => props.theme.fonts.montserratMedium};
  font-size: 15px;
  color: ${props => props.theme.colors.siteBlack};
  text-align: center;
  margin-bottom: 16px;
`;
const MobileWhiteBox = styled.div`
  background: ${props => props.theme.colors.white};
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1.5px solid ${props => props.theme.colors.lightGrey};
  padding: 16px 10px;
  margin-bottom: 18px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const MobileListTitle = styled.div`
  font-family: ${props => props.theme.fonts.montserratBold};
  font-size: 15px;
  color: ${props => props.theme.colors.siteBlack};
  margin-bottom: 8px;
`;
const MobileList = styled.ul`
  padding-left: 18px;
  margin: 0 0 8px 0;
  font-size: 13px;
  color: ${props => props.theme.colors.siteBlack};
  font-family: ${props => props.theme.fonts.montserratMedium};
`;
const MobileListItem = styled.li`
  margin-bottom: 7px;
  line-height: 1.5;
  b {
    font-family: ${props => props.theme.fonts.montserratBold};
  }
`;
const MobileEmailSection = styled.div`
  margin-top: 10px;
  font-size: 13px;
  color: ${props => props.theme.colors.siteBlack};
  font-family: ${props => props.theme.fonts.montserratMedium};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const MobileEmail = styled.a`
  color: ${props => props.theme.colors.siteBlue};
  font-family: ${props => props.theme.fonts.montserratBold};
  font-size: 15px;
  word-break: break-all;
  margin-top: 2px;
`;
const MobileDivider = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  margin: 12px 0;
  width: 100%;
`;
const MobileText = styled.div`
  color: ${props => props.theme.colors.toggleSwitchGrey};
  font-size: 13px;
  line-height: 1.7;
  text-align: left;
  margin-bottom: 16px;
  font-family: ${props => props.theme.fonts.montserratMedium};
`;
const MobileContact = styled.span`
  color: ${props => props.theme.colors.siteBlue};
  font-family: ${props => props.theme.fonts.montserratBold};
  font-size: 13px;
  cursor: pointer;
`;
const MobileImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;
const MobileImage = styled.img`
  max-width: 100%;
  height: 120px;
  object-fit: contain;
`;

export const SuccessPageMobile = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const handleContactUsClick = () => {
    window.open('https://www.rapnet.com/contact/support/', '_blank');
  };
  return (
    <MobileWrapper>
      <MobileContent>
        <MobileTitle>{TRANSLATION_TEXT.thank_you_for_subscribing}</MobileTitle>
        <MobileSubtitle>{TRANSLATION_TEXT.process_your_rapnet_membership}</MobileSubtitle>
        <MobileWhiteBox>
          <MobileListTitle>We require these documents:</MobileListTitle>
          <MobileList>
            <MobileListItem>
              <b>Active Business License / Certificate of Incorporation</b>
              <br />
              Confirming your involvement in the diamond or jewelry trade.
            </MobileListItem>
            <MobileListItem>
              <b>Government-issued Photo ID</b>
              <br />
              Required for the company owner and employees needing RapNet access.
            </MobileListItem>
            <MobileListItem>
              <b>Trade Reputation & Industry Affiliation</b>
              <ul style={{ paddingLeft: 16, margin: 0 }}>
                <li>
                  <b>Two Trade References</b> - From diamond or jewelry companies you've worked with
                  in the last 6 months (client for at least 1 year).
                </li>
                <li>
                  <b>Two Trade Invoices</b> - Dated within the last 6 months.
                </li>
              </ul>
            </MobileListItem>
          </MobileList>
          <MobileEmailSection>
            <div>Please email these documents to</div>
            <MobileEmail href="mailto:compliance@rapaport.com">compliance@rapaport.com</MobileEmail>
          </MobileEmailSection>
        </MobileWhiteBox>
        <MobileDivider />
        <MobileText>
          <div>
            A RapNet representative will follow up with you within 48 hours to process your
            membership.
            <br />
            Your subscription will be activated once all documents are approved, and payment has
            been received.
          </div>
          <div style={{ marginTop: 10 }}>
            If you have any questions, please feel free to{' '}
            <MobileContact onClick={handleContactUsClick}>contact us</MobileContact>.
          </div>
        </MobileText>
        <MobileImageContainer>
          <MobileImage src={diamondsBackground} alt="Diamonds" />
        </MobileImageContainer>
      </MobileContent>
    </MobileWrapper>
  );
};
